import React from 'react'
import { Progress } from 'reactstrap'
import MyGallery from './gallery'

const ProductConfirm = (props) => {
  /* eslint-disable no-unused-vars */
  const { product, quantity, setQuantity } = props
    const handleAdd = () => {
      if (quantity < product.limitPerOrder) setQuantity(quantity + 1)
    }

  const handleSub = () => {
    if (quantity > 0) setQuantity(quantity - 1)
  }
  const orderCount = Number(product.splitCasePurchase.orderCount) || 0
  const itemsPerCase = Number(product.splitCasePurchase.itemsPerCase) || 1
  const currentCount =
    (orderCount + quantity) % itemsPerCase === 0 && orderCount + quantity !== 0
      ? itemsPerCase
      : (orderCount + quantity) % itemsPerCase
      const needMore =
        itemsPerCase - currentCount === itemsPerCase && orderCount + quantity !== 0
          ? 0
          : itemsPerCase - currentCount

  const progressPercentage = (((orderCount + quantity) % itemsPerCase) / itemsPerCase) * 100
    return (
      <div className='detail-list-news__item'>
        <div className='row'>
          <div className='col-3'>
            <MyGallery image={product?.splitCasePurchase.photoUrl || product?.photoUrls[0]} />
          </div>
          <div className='col-6'>
            <h3>{product?.splitCasePurchase.name}</h3>
            <span className='text-secondary' style={{ fontSize: '13px' }}>
              Individual pieces (split case)
            </span>
            <p className='mb-0'>${(product?.splitCasePurchase.costPerItem).toFixed(2)}</p>
            <div className='d-flex align-items-center' style={{ gap: 8 }}>
              <Progress
                value={progressPercentage}
                barStyle={{ backgroundColor: '#ea6f84' }}
                className='mb-0'
                style={{ height: '8px', flex: 1, minWidth: 0 }}
              />
              <span
                className='text-secondary'
                style={{ fontSize: '13px', flexShrink: 0, marginLeft: 8 }}
              >
                ({currentCount}/{itemsPerCase})
              </span>
            </div>
            <span style={{ fontSize: '13px', color: '#ea6f84' }}>
              Need {needMore} more to fulfill orders
            </span>
          </div>
          <div className='col-3'>
            <div className='quanlity'>
              <span className='icon-mim' onClick={handleSub}>
                -
              </span>
              <span className='icon-input'>
                <input
                  type='number'
                  step='1'
                  min='0'
                  max={product.limitPerOrder}
                  className='form-control'
                  value={quantity}
                />
              </span>
              <span className='icon-plugs' onClick={handleAdd}>
                +
              </span>
            </div>
          </div>
        </div>
      </div>
    )
}

export default ProductConfirm
